import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import DashboardView from "../views/DashboardView.vue";
import MembersView from "../views/MembersView.vue";
import RaportSaptamanalView from "../views/RaportSaptamanalView.vue";
import ConturiView from "../views/ConturiView.vue";

const routes = [
  { path: "/", name: "Login", component: LoginView },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardView,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem("token");
      if (token) {
        next();
      } else {
        next({ name: "Login" });
      }
    },
  },
  {
    path: "/membri",
    name: "Members",
    component: MembersView,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem("token");
      if (token) {
        next();
      } else {
        next({ name: "Login" });
      }
    },
  },
  {
    path: "/raport-saptamanal",
    name: "RaportSaptamanal",
    component: RaportSaptamanalView,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem("token");
      if (token) {
        next();
      } else {
        next({ name: "Login" });
      }
    },
  },
  {
    path: "/conturi",
    name: "Conturi",
    component: ConturiView,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("role"); // Verificăm rolul utilizatorului
      if (token && userRole === "Owner") {
        next();
      } else {
        next({ name: "Login" }); // Redirecționează spre login dacă nu are acces
      }
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
